/**
 * App Store screenshot mode (see docs/mealmap/APPSTORE_SCREENSHOTS.md).
 *
 * OFF by default. Only turned on by launching the iOS app with the launch
 * argument `-AWScreenshotMode 1` (what `yarn ios:screenshots` does via
 * `xcrun simctl launch`). iOS puts launch arguments into NSUserDefaults'
 * argument domain, which RN's built-in `Settings` module reads, so no native
 * code or new dependency is needed. Store users cannot pass launch
 * arguments, and nothing ever writes these keys to persistent defaults.
 * Android: the same names as intent extras (`adb shell am start -e
 * AWScreenshotMode 1 -e AWScreen home`), read only by builds made with
 * `-PawScreenshots=true` (what `yarn android:screenshots` does). Web: always off.
 *
 * In this mode the app uses fixture data (no network), skips sign-in, hides
 * the bug-report FAB, and opens the screen named by `-AWScreen <name>`.
 */
import { NativeModules, Platform, Settings } from 'react-native';
export const SCREENSHOT_SCREENS = [
    'signin',
    'home',
    'meal-map',
    'meal-entry',
    'water',
    'weigh-in',
    'exercise',
];
const readSetting = (key) => {
    if (Platform.OS === 'android') {
        // Intent extras, only populated in -PawScreenshots=true builds
        // (see ScreenshotLaunchArgsModule.kt).
        const args = NativeModules.AWLaunchArgs?.getConstants?.() ?? NativeModules.AWLaunchArgs;
        const v = args?.[key];
        return v == null ? undefined : v;
    }
    if (Platform.OS !== 'ios') {
        return undefined;
    }
    try {
        return Settings.get(key);
    }
    catch {
        return undefined;
    }
};
const flag = readSetting('AWScreenshotMode');
export const SCREENSHOT_MODE = flag === 1 || flag === '1' || flag === true || flag === 'YES';
const requested = readSetting('AWScreen');
export const SCREENSHOT_SCREEN = SCREENSHOT_MODE &&
    typeof requested === 'string' &&
    SCREENSHOT_SCREENS.includes(requested)
    ? requested
    : 'home';
